var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import Vue from 'vue';
import { Store, SubModule, Mutation } from './annotations';
import { NotificationStore } from './NotificationStore';
import { DialogStore } from './DialogStore';
const notificationStore = new NotificationStore();
const dialogStore = new DialogStore();
let UiStore = class UiStore extends Vue {
    constructor() {
        super(...arguments);
        /** Indica el estado del loader global de la app */
        this.loader = false;
        /** Submodulo que maneja el estado de las notificaciones (Toast) */
        this.notification = notificationStore;
        /** Submodulo que maneja el estado del modal global de la app */
        this.dialog = dialogStore;
    }
    showLoader() {
        this.loader = true;
    }
    hideLoader() {
        this.loader = false;
    }
    changeTheme(value) {
        this.theme = value;
    }
    toggleTheme() {
        this.changeTheme(this.theme === 'light' ? 'dark' : 'light');
    }
};
__decorate([
    SubModule,
    __metadata("design:type", Object)
], UiStore.prototype, "notification", void 0);
__decorate([
    SubModule,
    __metadata("design:type", Object)
], UiStore.prototype, "dialog", void 0);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], UiStore.prototype, "showLoader", null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], UiStore.prototype, "hideLoader", null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], UiStore.prototype, "changeTheme", null);
UiStore = __decorate([
    Store
], UiStore);
export default UiStore;
//# sourceMappingURL=UiStore.js.map